var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60057 8.9905L7.92901 10.2352C8.73512 10.9906 10.0009 10.9493 10.7561 10.1431L14.2191 6.44618C14.9741 5.64012 14.9329 4.37463 14.1269 3.61946L13.3571 2.89817C12.5511 2.14293 11.2854 2.1841 10.5302 2.99013L9.10703 4.50898",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39943 8.0095L8.07099 6.76477C7.26488 6.00944 5.99906 6.05071 5.24386 6.85694L1.78093 10.5538C1.02589 11.3599 1.06715 12.6254 1.87309 13.3805L2.64288 14.1018C3.44891 14.8571 4.71457 14.8159 5.46981 14.0099L6.89297 12.491",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.0dd177417948a9a45fe3b8f6070bde6d.svg";
export { ForwardRef as ReactComponent };